import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  name: '',
  code: '',
  products: [],
  contacts: {
    maxCount: '',
    type: ''
  },
  experienceSettings: {
    messageParams: {
      senderName: '',
      message: '',
      aboutMessage: '',
      customizedRecipientMessages: {}
    },
    branding: {
      giftWrapperUrl: '',
      logoUrl: ''
    },
    occasion: ''
  },
  meta: {},
  settings: {
    recipientVerification: {}
  },
  emails: [],
  addons: []
};

let store = set => ({
  ...initialState,
  updateName: name => {
    set(() => ({
      name
    }));
  },
  updateCode: code => {
    set(() => ({
      code
    }));
  },
  updateProducts: products => {
    set(() => ({
      products
    }));
  },
  updateContacts: contacts => {
    set(() => ({
      contacts
    }));
  },
  updateExperienceSettings: experienceSettings => {
    set(() => ({
      experienceSettings
    }));
  },
  onUpdateBranding: branding => {
    set(({ experienceSettings }) => ({
      experienceSettings: {
        ...experienceSettings,
        branding: {
          ...experienceSettings.branding,
          ...branding
        }
      }
    }));
  },
  onUpdateOccasion: occasion => {
    set(({ experienceSettings }) => ({
      experienceSettings: {
        ...experienceSettings,
        occasion
      }
    }));
  },
  onUpdateMessageParams: messageParams => {
    set(({ experienceSettings }) => ({
      experienceSettings: {
        ...(experienceSettings || {}),
        messageParams: {
          ...(experienceSettings?.messageParams || {}),
          ...messageParams
        }
      }
    }));
  },
  updateSettings: settings => {
    set(() => ({
      settings
    }));
  },
  updateRecipientVerification: recipientVerification => {
    set(({ settings }) => ({
      settings: {
        ...settings,
        recipientVerification
      }
    }));
  },
  updateMeta: meta => {
    set(() => ({
      meta
    }));
  },
  updateEmails: emails => {
    set(() => ({
      emails
    }));
  },
  updateAddons: addons => {
    set(() => ({
      addons
    }));
  },
  reset: () => set(initialState)
});

store = persist(store, {
  name: 'newRecognition',
  storage: createJSONStorage(() => sessionStorage)
});
export const useNewRecognitionStore = create(devtools(store));
